import { jsx as _jsx } from "react/jsx-runtime";
import { useGLTF } from "@react-three/drei";
import { ContentHashMap } from "../../../core/util/ContentHashMap";
import { Mesh } from "three";
import { useEffect, useMemo, useState } from "react";
import { setVector } from "./SpatialUtils";
export const useModelTemplate = (url, onModelLoaded) => {
    if (ContentHashMap.getContentHashPath(url) === undefined) {
        throw new Error(`Model URL ${url} not found!`);
    }
    const gltf = useGLTF(ContentHashMap.getContentHashPath(url));
    return useMemo(() => ({
        templateModel: gltf,
        onModelLoaded,
        hasLoaded: false,
    }), [gltf]);
};
export const Model = (props) => {
    const { template, initialTransform, castShadow, receiveShadow, modelRef, onCreateInstance } = props;
    const [model, setModel] = useState(undefined);
    useEffect(() => {
        const { templateModel, onModelLoaded, hasLoaded } = template;
        if (!hasLoaded) {
            template.hasLoaded = true;
            onModelLoaded === null || onModelLoaded === void 0 ? void 0 : onModelLoaded(templateModel.scene);
        }
        const newModel = templateModel.scene.clone();
        if ((initialTransform === null || initialTransform === void 0 ? void 0 : initialTransform.position) !== undefined) {
            setVector(newModel.position, initialTransform.position);
        }
        if ((initialTransform === null || initialTransform === void 0 ? void 0 : initialTransform.quaternion) !== undefined) {
            newModel.setRotationFromQuaternion(initialTransform.quaternion);
        }
        else if ((initialTransform === null || initialTransform === void 0 ? void 0 : initialTransform.rotation) !== undefined) {
            newModel.setRotationFromEuler(initialTransform.rotation);
        }
        if ((initialTransform === null || initialTransform === void 0 ? void 0 : initialTransform.scale) !== undefined) {
            setVector(newModel.scale, initialTransform.scale);
        }
        if (onCreateInstance !== undefined) {
            onCreateInstance(newModel);
        }
        recursivelySetShadowProps(newModel, castShadow !== null && castShadow !== void 0 ? castShadow : false, receiveShadow !== null && receiveShadow !== void 0 ? receiveShadow : false);
        if (modelRef !== undefined) {
            modelRef.current = newModel;
        }
        setModel(newModel);
        return () => {
            recursivelyDispose(newModel);
        };
    }, [template, setModel, castShadow, receiveShadow, onCreateInstance]);
    return model && _jsx("primitive", { object: model });
};
function recursivelySetShadowProps(current, castShadow, receiveShadow) {
    if (current instanceof Mesh) {
        current.castShadow = castShadow;
        current.receiveShadow = receiveShadow;
    }
    for (const child of current.children) {
        recursivelySetShadowProps(child, castShadow, receiveShadow);
    }
}
function recursivelyDispose(disposable) {
    if (disposable instanceof Mesh) {
        disposable.geometry.dispose();
    }
    for (const child of disposable.children) {
        recursivelyDispose(child);
    }
}
export function setMaterialRecursively(object, material) {
    if (object instanceof Mesh) {
        object.material = material;
    }
    for (const child of object.children) {
        setMaterialRecursively(child, material);
    }
}
//# sourceMappingURL=useModel.js.map